
<template>
  <div class="home full-height home-banner">
    <ld-header transparent @click-left="function () { }" @click-right="$router.push({ path: '/service' })">
      <template #left>
        <span class="logo font18 white">
          {{ loginConfig.pageName }}
        </span>
      </template>
      <!-- 右上客服 -->
      <template #right>
        <div class="server">
          <van-icon name="service" />
          <p class="font12">
            {{ $t('A022', '专属客服') }}
          </p>
        </div>
      </template>
    </ld-header>

    <div class="home-notice">
      <van-notice-bar v-if="loginNotices && loginNotices.length" class=" full-width round-sm" left-icon="volume-o"
                      style="height: 28px;" mode="closeable">
        <span v-for="notice in loginNotices" :key="notice.id"
              @click="$router.push({ path: `/userCenter/noticeDetail/${notice.id}` })">
          {{ notice.content }}
        </span>
      </van-notice-bar>
    </div>

    <div class="welcome font18 white">
      {{ $t('A029', '欢迎您') }}，{{ userInfo && userInfo.empInfo && userInfo.empInfo.empName }}
      <div class="white font24 font-lg" v-ldsk="userInfo && userInfo.vipCorp ? userInfo.vipCorp.corpNo : ''">
        {{ userInfo && userInfo.vipCorp && userInfo.vipCorp.fullname }}
      </div>
    </div>

    <!-- Menu -->
    <div class="menu bg-white">
      <van-grid :column-num="4" :border="false" icon-size="44">
        <van-grid-item v-for="tab in menuList" :key="tab.link" :to="tab.link" :icon="tab.img" :text="$t(tab.title)"
                       :class="[tab.openDiasble ? 'menu-disabled' : '']" @click="to(tab)" />
      </van-grid>
      <!--   -->
      <van-grid :column-num="4" :border="false" style="flex-wrap: nowrap;">
        <van-grid-item v-for="(item, index) in menuList_other" :key="index"
                       :class="[item.openDiasble ? 'menu-disabled' : '']" @click="to(item)">
          <template #icon>
            <ld-icon :color="item.color" size="30" :type="item.icon" />
            <van-icon :name="item.img" size="28" />
          </template>
          <template #text>
            <span class="van-grid-item__text" :style="{ color: item.disabled && '#ccc' }">{{ $t(item.title) }}</span>
          </template>
        </van-grid-item>
      </van-grid>

      <!--  -->
      <!-- <van-grid
        :column-num="5"
        :border="false"
        style="flex-wrap: nowrap;"
      >
        <van-grid-item
          v-for="tab in menuList_minor"
          :key="tab.link"
          :to="tab.link"
          :url="tab.url"
          :icon="tab.img"
          :text="$t(tab.title)"
        />
      </van-grid> -->
    </div>

  </div>
</template>

<script>
// import { mapGetters, mapActions } from 'vuex'
import { Tabbar, TabbarItem, Popup, Grid, GridItem, Icon, NoticeBar } from 'vant'
// import { update } from 'CommonUtils/updateApp.js'

// import menu_tk from 'Assets/images/home/menu_tk.png'
// import menu_ht from 'Assets/images/home/menu_ht.png'
// import menu_tr from 'Assets/images/home/menu_tr.png'
// import menu_car from 'Assets/images/home/menu_car.png'
// import menu_visa from 'Assets/images/home/menu_visa.png'

import menu_strategy from 'Assets/images/home/menu_strategy.png'
import menu_discount from 'Assets/images/home/menu_discount.png'
import menu_freebus from 'Assets/images/home/menu_freebus.png'
import menu_contracthotel from 'Assets/images/home/menu_contracthotel.png'
import menu_policy from 'Assets/images/home/menu_policy.png'

import menu_checkIn from 'Components/Dynamic/bjzxyx/images/menu/checkIn.png'
import menu_guestPass from 'Components/Dynamic/bjzxyx/images/menu/guestPass.png'
import menu_fastCheck from 'Components/Dynamic/bjzxyx/images/menu/fastCheck.png'
import menu_restRoom from 'Components/Dynamic/bjzxyx/images/menu/restRoom.png'
import menu_tk from 'Components/Dynamic/bjzxyx/images/menu/tk.png'
import menu_tr from 'Components/Dynamic/bjzxyx/images/menu/tr.png'
import menu_ht from 'Components/Dynamic/bjzxyx/images/menu/ht.png'
import menu_car from 'Components/Dynamic/bjzxyx/images/menu/car.png'
import menu_visa from 'Components/Dynamic/bjzxyx/images/menu/visa.png'
import menu_other from 'Components/Dynamic/bjzxyx/images/menu/other.png'


import ldHeader from 'Common/ldHeader'
import homeMixin from '../default/homeMixin'
// 北京尊享悦行
export default {
  name: 'Home',
  mixins: [homeMixin],
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Popup.name]: Popup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    ldHeader
  },
  data () {
    return {
      menuList: [
        {
          link: '/checkIn',
          title: '优先值机',
          img: menu_checkIn,
          badge: 'HOT'
        },
        {
          link: '/guestPass',
          title: '要客通',
          img: menu_guestPass,
        },
        {
          link: '/fastCheck',
          title: '快速安检',
          img: menu_fastCheck,
        },
        {
          link: '/restRoom',
          title: '休息室',
          img: menu_restRoom,
        },
      ],
      menuList_minor: [
        {
          link: '/tkIntel/policy',
          title: 'A019',//'国际特惠',
          img: menu_strategy
        },
        {
          link: '/tk/policy',
          title: 'A020',//'协议直减',
          img: menu_discount
        },
        {
          link: '/tk/airportBus',
          title: 'Q016',//机场大巴
          img: menu_freebus
        },
        {
          link: '/ht/htQuery/htSignList',
          title: 'A021',//'协议酒店',
          img: menu_contracthotel
        },
        {
          link: '/tk/strategy',
          title: 'Q007',//机场攻略
          img: menu_policy,
          openDiasble: true
        },
      ],
      menuList_other: [
        // {
        // 	link: '/tk/tkQuery',
        // 	title: 'A008',//机票
        // 	img: menu_tk,
        // },
        {
          link: '/ht/htQuery',
          title: 'A009',//酒店
          img: menu_ht
        },
        // {
        // 	link: '/tr/trQuery',
        // 	title: 'A010',//火车票
        // 	img: menu_tr
        // },
        // {
        //   link: '/car/carQuery',
        //   title: 'A011',//用车
        //   img: menu_car
        // },
        {
          link: '/visa',
          title: 'A012',//签证
          img: menu_visa,
          openDiasble: true
        },
        {
          link: '/',
          title: '敬请期待',
          img: menu_other,
          disabled: true
        }
      ],
    }
  },
  async created () {
    await this.getAuthorizationPnos()
    this.genMenu([...this.menuList, ...this.menuList_other])
    this.getLoginNotice(0) //获取登录公告
    this.getBadgeCount()
    this.checkOpenId()
  },
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: 'paopao';
  src: url('~Assets/font/paopao/paopao.ttf') format('truetype');
}

.home {
  position: relative;
  padding: 10px;
  background-size: cover;

  .logo {
    font-family: 'paopao';
  }

  .welcome {
    padding: 5px 10px;
  }

  .home-notice {
    padding: 5px 10px;
  }

  .server {
    color: @color-text-white !important;
    font-size: 24px;

    >p {
      margin-top: -3px;
    }

    .van-icon {
      color: @color-text-white !important;
    }
  }

  .menu {
    position: absolute;
    bottom: 60px;
    width: 7.1rem;
    padding: 8px;
    border-radius: @border-radius-md;

    .more {
      margin-top: 15px;
      line-height: 36px;
    }
  }

}
</style>
